import { Controller } from "@hotwired/stimulus"

// Drives the Back Office "Créer nouvel espace" button through three states on click:
// creating (spinner) → created (confirmation) → back to the idle label, each visible for `duration` ms.
// It POSTs with `fetch` instead of a form so it never triggers a Turbo frame navigation (which would
// flash the global Back Office loader), and the button element survives to animate through the states.
export default class extends Controller {
  static values = {
    url: String,
    creatingText: String,
    createdText: String,
    duration: { type: Number, default: 2000 }
  }

  connect() {
    this.idleLabel = this.element.innerHTML
  }

  async create() {
    if (this.element.disabled) return
    this.setState("fa-spinner fa-spin", this.creatingTextValue)

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const [response] = await Promise.all([
      fetch(this.urlValue, {
        method: "POST",
        headers: { Accept: "text/vnd.turbo-stream.html", "X-CSRF-Token": token },
        credentials: "same-origin"
      }),
      this.wait(this.durationValue)
    ])

    Turbo.renderStreamMessage(await response.text())
    if (!response.ok) return this.restore()

    this.setState("fa-circle-check", this.createdTextValue)
    await this.wait(this.durationValue)
    this.restore()
  }

  setState(icon, text) {
    this.element.disabled = true
    this.element.innerHTML =
      `<span class="d-flex justify-content-center align-items-center">` +
      `<i class="fa-solid mr-2 ${icon}"></i><span>${text}</span></span>`
  }

  restore() {
    this.element.disabled = false
    this.element.innerHTML = this.idleLabel
  }

  wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms))
  }
}
